import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpimprichichwad() {



    const cardData = {

keyword: "Urbania on Rent in Pimpri Chinchwad",

headingDescription:
    "Rising Cab Service offers premium Urbania on Rent in Pimpri Chinchwad for corporate travel, weddings, airport transfers, family tours, and outstation group journeys. Our Force Urbania vehicles come with luxury high-roof interiors, push-back reclining seats, powerful air conditioning, ambient lighting, ample luggage space, and experienced professional chauffeurs. With doorstep pickup across Pimpri Chinchwad and nearby areas, flexible rental packages, 24/7 support, and transparent pricing, we ensure a safe, comfortable, and premium travel experience for large groups and VIP transportation needs.",

topPlaces: [
    {
        title: "Lonavala & Khandala Premium Trip",
        description:
            "Lonavala and Khandala are the most popular hill stations near Pimpri Chinchwad, known for lush green valleys, waterfalls, and scenic viewpoints. Urbania rental is perfect for luxury group travel, offering spacious seating and comfort for families, corporate teams, and wedding groups enjoying monsoon drives and weekend getaways."
    },
    {
        title: "Mahabaleshwar Luxury Tour",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. Urbania ensures a premium travel experience for large groups visiting waterfalls, viewpoints, and scenic attractions with maximum comfort and relaxation during the journey."
    },
    {
        title: "Goa Luxury Beach Vacation",
        description:
            "Goa is a top long-distance destination known for beaches, nightlife, and adventure activities. Urbania on rent is ideal for VIP group travel, wedding trips, and luxury vacations, ensuring a smooth and comfortable highway journey from Pimpri Chinchwad."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Urbania provides premium group travel for darshan, ensuring a comfortable, spacious, and relaxed journey for families and devotees from Pimpri Chinchwad."
    },
    {
        title: "Nashik & Trimbakeshwar Tour",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and temples. Urbania rental is ideal for wine tours, corporate outings, and spiritual trips, offering a premium travel experience for groups exploring both religious and leisure destinations."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Urbania is perfect for large group spiritual tours, ensuring comfort, space, and smooth travel for devotees completing the religious circuit."
    },
    {
        title: "Alibaug Coastal Luxury Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Urbania rental is ideal for luxury group outings, corporate retreats, and beach vacations from Pimpri Chinchwad with comfortable travel experience."
    },
    {
        title: "Konkan Scenic Beach Tour",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, Harihareshwar, and Tarkarli offers beautiful beaches and greenery. Urbania ensures a smooth and comfortable long-distance journey for luxury coastal group tours from Pimpri Chinchwad."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. Urbania is ideal for premium heritage tours, educational trips, and family cultural journeys from Pimpri Chinchwad with comfort and style."
    },
    {
        title: "Corporate & Wedding Group Travel",
        description:
            "Urbania is widely used in Pimpri Chinchwad for corporate travel, wedding transportation, and VIP group movement. It offers spacious interiors, luxury seating, and a smooth ride experience for important events and professional travel needs."
    }
],



services: [
  {
    name: "17 Seater Urbania on Rent Pimpri Chinchwad",
    description: "Rising Cab Service offers 17 Seater Urbania on Rent Pimpri Chinchwad for premium group travel, weddings, corporate events, family tours, airport transfers, and outstation journeys. Our Force Urbania vehicles feature luxurious interiors, spacious seating, ample legroom, air conditioning, modern amenities, and professional chauffeurs. Ideal for travelers seeking comfort, safety, and a premium travel experience across Pune and Maharashtra."
  },
  {
    name: "Urbania Traveller on Rent in Pimpri",
    description: "Book Urbania Traveller on Rent in Pimpri for luxury transportation with comfortable seating, spacious cabins, and professional drivers. Perfect for family trips, business travel, wedding transportation, and group outings requiring superior comfort."
  },
  {
    name: "Urbania on Rent in Chinchwad",
    description: "Urbania on Rent in Chinchwad provides premium group transportation for weddings, sightseeing tours, corporate travel, and airport transfers. Enjoy modern interiors, comfortable seating, and reliable service with experienced chauffeurs."
  },
  {
    name: "20 Seater Urbania on Rent PCMC",
    description: "Hire a 20 Seater Urbania on Rent PCMC for larger groups seeking luxury transportation. Ideal for corporate events, family functions, wedding guest transportation, and outstation travel with spacious seating and premium comfort."
  },
  {
    name: "Urbania Van Rental Pimpri Chinchwad",
    description: "Urbania Van Rental Pimpri Chinchwad offers elegant and comfortable transportation solutions for weddings, business meetings, family vacations, and group travel with well-maintained luxury vehicles."
  },
  {
    name: "Urbania Traveller Booking in PCMC",
    description: "Urbania Traveller Booking in PCMC allows quick reservations with transparent pricing, instant confirmations, and professional chauffeur service for local and outstation travel."
  },
  {
    name: "Urbania Hire in Pimpri Chinchwad",
    description: "Urbania Hire in Pimpri Chinchwad provides premium travel solutions for corporate groups, family tours, weddings, and airport transfers. Enjoy safe and comfortable travel in luxury Urbania vehicles."
  },
  {
    name: "Urbania on Rent Near Me PCMC",
    description: "Looking for Urbania on Rent Near Me PCMC? Rising Cab Service offers doorstep pickup, luxury seating, professional drivers, and flexible rental packages for all travel requirements."
  },
  {
    name: "Urbania Luxury Vehicle on Rent Pimpri Chinchwad",
    description: "Urbania Luxury Vehicle on Rent Pimpri Chinchwad offers premium transportation with spacious interiors, comfortable pushback seating, modern amenities, and exceptional travel comfort for VIP and group travel."
  },
  {
    name: "Urbania on Rent in Pimpri Chinchwad for Wedding",
    description: "Book Urbania on Rent in Pimpri Chinchwad for Wedding functions and enjoy luxury transportation for family members, guests, and wedding parties. Our vehicles ensure stylish arrivals and comfortable travel."
  },
  {
    name: "Urbania Traveller for Wedding Function PCMC",
    description: "Urbania Traveller for Wedding Function PCMC provides organized transportation for wedding guests, family members, and event participants with luxury seating and professional chauffeur service."
  },
  {
    name: "Urbania on Rent for Marriage Ceremony Pimpri Chinchwad",
    description: "Urbania on Rent for Marriage Ceremony Pimpri Chinchwad offers elegant and reliable transportation for marriage functions, receptions, and related celebrations with spacious interiors and premium comfort."
  },
  {
    name: "17 Seater Urbania for Wedding in PCMC",
    description: "17 Seater Urbania for Wedding in PCMC is ideal for transporting wedding guests and family members comfortably. Enjoy luxurious interiors, professional drivers, and hassle-free event transportation."
  },
  {
    name: "Urbania Hire for Wedding Guests Pimpri Chinchwad",
    description: "Urbania Hire for Wedding Guests Pimpri Chinchwad ensures convenient guest transportation with comfortable seating, punctual pickups, and reliable service throughout wedding events."
  },
  {
    name: "Urbania Hire Pune for Corporate Meetings & Conferences",
    description: "Urbania Hire Pune for Corporate Meetings & Conferences offers executive transportation solutions for business teams, conferences, seminars, and professional gatherings with luxury travel standards."
  },
  {
    name: "Urbania Van for Corporate Transportation Pune",
    description: "Urbania Van for Corporate Transportation Pune provides reliable employee travel, executive transportation, client transfers, and corporate event mobility with premium comfort and professionalism."
  },
  {
    name: "Urbania Traveller Hire for Business Events Pune",
    description: "Urbania Traveller Hire for Business Events Pune is designed for corporate groups attending exhibitions, meetings, conferences, and networking events. Our luxury vehicles ensure a professional travel experience."
  },
  {
    name: "Urbania Van Rental for Wedding in PCMC",
    description: "Urbania Van Rental for Wedding in PCMC provides elegant transportation for wedding functions, guest transfers, and event logistics with spacious luxury vehicles and professional service."
  },
  {
    name: "Luxury Urbania on Rent for Wedding Pimpri",
    description: "Luxury Urbania on Rent for Wedding Pimpri offers premium interiors, comfortable seating, and stylish transportation solutions for weddings, receptions, and special celebrations."
  },
  {
    name: "Urbania Traveller Booking for Wedding Chinchwad",
    description: "Urbania Traveller Booking for Wedding Chinchwad provides seamless wedding transportation with advance booking options, professional drivers, and luxury travel arrangements."
  },
  {
    name: "Urbania for Marriage Event Transportation PCMC",
    description: "Urbania for Marriage Event Transportation PCMC offers complete guest transportation management for marriage ceremonies, receptions, and family events with spacious and luxurious vehicles."
  }
],

tableData: [
  ["17 Seater Urbania on Rent Pimpri Chinchwad", "Urbania Traveller on Rent in Pimpri"],
  ["Urbania on Rent in Chinchwad", "20 Seater Urbania on Rent PCMC"],
  ["Urbania Van Rental Pimpri Chinchwad", "Urbania Traveller Booking in PCMC"],
  ["Urbania Hire in Pimpri Chinchwad", "Urbania on Rent Near Me PCMC"],
  ["Urbania Luxury Vehicle on Rent Pimpri Chinchwad", "Urbania on Rent in Pimpri Chinchwad for Wedding"],
  ["Urbania Traveller for Wedding Function PCMC", "Urbania on Rent for Marriage Ceremony Pimpri Chinchwad"],
  ["17 Seater Urbania for Wedding in PCMC", "Urbania Hire for Wedding Guests Pimpri Chinchwad"],
  ["Urbania Hire Pune for Corporate Meetings & Conferences", "Urbania Van for Corporate Transportation Pune"],
  ["Urbania Traveller Hire for Business Events Pune", "Urbania Van Rental for Wedding in PCMC"],
  ["Luxury Urbania on Rent for Wedding Pimpri", "Urbania Traveller Booking for Wedding Chinchwad"],
  ["Urbania for Marriage Event Transportation PCMC", "Urbania Hire in Pimpri Chinchwad"]
],




whychoose: [
    {
        WhyChooseheading: "Premium Urbania on Rent in Pimpri Chinchwad",
        WhyChoosedescription: "Rising Cab Service provides luxury Force Urbania rental services in Pimpri Chinchwad for family tours, corporate travel, weddings, airport transfers, pilgrimages, and group transportation."
    },
    {
        WhyChooseheading: "Luxury Travel Experience with Modern Comfort",
        WhyChoosedescription: "Force Urbania offers premium pushback seating, spacious interiors, wide windows, superior legroom, and a smooth ride for long-distance travel."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Family Groups",
        WhyChoosedescription: "Urbania is ideal for corporate outings, executive travel, destination weddings, family vacations, school groups, and VIP guest transportation."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Urbania rental services are available from Pimpri Chinchwad for Pune city travel and destinations such as Goa, Mahabaleshwar, Shirdi, Nashik, Mumbai, Konkan, Kolhapur, and Lonavala."
    },
    {
        WhyChooseheading: "Spacious Seating and Premium Amenities",
        WhyChoosedescription: "Passengers enjoy comfortable seating, powerful air conditioning, ample luggage space, charging facilities, and luxury interiors throughout the journey."
    },
    {
        WhyChooseheading: "Pickup Available Across PCMC Areas",
        WhyChoosedescription: "Urbania pickup services are available from Pimpri, Chinchwad, Wakad, Ravet, Punawale, Nigdi, Akurdi, Bhosari, Moshi, Pimple Saudagar, Tathawade, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Experienced chauffeurs ensure safe highway driving, punctual service, route expertise, and a comfortable travel experience."
    },
    {
        WhyChooseheading: "Best Choice for Luxury Group Transportation",
        WhyChoosedescription: "Force Urbania is widely preferred for corporate events, pilgrimage tours, family holidays, airport transfers, destination weddings, and sightseeing trips."
    }
]
};

const faqData = [
    {
        question: "What is Urbania on Rent in Pimpri Chinchwad?",
        answer: "Urbania rental service provides a luxury passenger vehicle for family tours, corporate travel, weddings, airport transfers, and outstation group transportation."
    },
    {
        question: "Can I hire Urbania for outstation travel from PCMC?",
        answer: "Yes, Urbania vehicles are available for destinations across Maharashtra and other states."
    },
    {
        question: "Is Force Urbania suitable for corporate travel?",
        answer: "Yes, Urbania is highly preferred for executive transportation, employee travel, conferences, and business events."
    },
    {
        question: "Can Urbania be booked for weddings and family functions?",
        answer: "Yes, Urbania is commonly hired for wedding guest transportation, destination weddings, and family celebrations."
    },
    {
        question: "Is the vehicle comfortable for long-distance journeys?",
        answer: "Yes, Urbania offers premium seating, spacious interiors, and excellent comfort for extended travel."
    },
    {
        question: "Can families hire Urbania for vacations and sightseeing tours?",
        answer: "Yes, Urbania is ideal for family holidays, Konkan tours, hill station trips, and group vacations."
    },
    {
        question: "Do you provide Urbania for pilgrimage tours?",
        answer: "Yes, Urbania vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Are airport transfer services available with Urbania?",
        answer: "Yes, Urbania can be booked for Pune Airport, Mumbai Airport, and VIP guest transportation services."
    },
    {
        question: "Which PCMC areas are covered for pickup?",
        answer: "Pickup services are available from Pimpri, Chinchwad, Wakad, Nigdi, Ravet, Punawale, Akurdi, Bhosari, Moshi, Tathawade, and nearby locations."
    },
    {
        question: "How can I book Urbania on Rent in Pimpri Chinchwad?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Jadhav",
        feedback:
            "We booked an Urbania from Wakad for our Goa family vacation. The luxury seating, spacious cabin, and comfortable ride made the entire journey enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali More",
        feedback:
            "Our corporate group hired an Urbania from Pimpri Chinchwad for an outstation event. The vehicle was premium, well-maintained, and perfect for executive travel.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Urbania on Rent in Pimpri Chinchwad",
"image": "https://www.risingcabservice.com/assets/images/urbania-pimpri-chinchwad.jpg",
"description": "Book Urbania on Rent in Pimpri Chinchwad (PCMC) with Rising Cab Service for premium group travel, corporate trips, weddings, and outstation journeys. Available in 17 and 20 seater luxury AC Urbania vans with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹28/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/urbania-on-rent-pimpri-chinchwad"
}
};







    return (
        <div>
<Helmet>
  <title>Urbania on Rent in Pimpri Chinchwad | PCMC Luxury Van | +91 9272511548</title>

<meta
 name="description"
 content="Book Urbania on Rent in Pimpri Chinchwad (PCMC) for premium group travel, corporate trips, weddings, and outstation journeys. Get 17 & 20 seater luxury AC vans with driver."
/>

<meta
 name="keywords"
 content="urbania on rent pimpri chinchwad, urbania traveller pimpri, urbania chichwad rent, 17 seater urbania pcmc, 20 seater urbania pcmc, urbania van rental pimpri chinchwad, urbania booking pcmc, luxury van pimpri chinchwad"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpimprichichwad;